import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem, CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DataTable from "../components/DataTable";
import SearchIcon from "@mui/icons-material/Search";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import SnackbarAlert from "../components/SnackbarAlert";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
export default function Users() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [search, setSearch] = useState("");
    const [stateData, setStateData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [planData, setPlanData] = useState([]);
    const [name, setName] = useState("");
    const [mobile, setMobile] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [town, setTown] = useState("");
    const [city, setCity] = useState("");
    const [district, setDistrict] = useState('');
    const [state, setState] = useState('');
    const [country] = useState("India");
    const [pincode, setPincode] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [open, setOpen] = useState(false);
    const [editState, setEditState] = useState(null);
    const [openCustomerModal, setOpenCustomerModal] = useState(false);
    const [openPlanModal, setOpenPlanModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [assignedPlan, setAssignedPlan] = useState(null);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    useEffect(() => {
        fetchUserstData();
    }, []);
    const fetchDistricts = async (stateId) => {
        setLoading(true);
        try {
            let url = webEndPoint + "districts/state/" + stateId;
            const response = await makeRequest("get", url);
            if (response) {
                setDistrictData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchUserstData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "users";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "states";
            const response = await makeRequest("get", url);
            if (response) {
                setStateData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "plans";
            const response = await makeRequest("get", url);
            if (response) {
                setPlanData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }

    };
    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        setState(selectedState);
        fetchDistricts(selectedState);
    };
    const openAdd = () => {
        resetForm();
        setOpen(true);
    };
    const openEdit = async (data) => {
        setLoading(true);
        try {
            let url = webEndPoint + "districts/state/" + data?.state_id;
            const response = await makeRequest("get", url);
            if (response) {
                setDistrictData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setEditState(data);
        setName(data?.user_name);
        setMobile(data?.mobile_number);
        setAddress1(data?.address_line1);
        setAddress2(data?.address_line2);
        setTown(data?.town);
        setCity(data?.city);
        setState(data?.state_id);
        setDistrict(data?.district_id);
        setPincode(data?.pincode);
        setOpen(true);
    };
    const resetForm = () => {
        setName("");
        setMobile("");
        setPassword("");
        setAddress1("");
        setAddress2("");
        setTown("");
        setCity("");
        setState("");
        setDistrict("");
        setPincode("");
        setDistrictData([]);
        setEditState(null);
        setShowPassword(false);
    };
    const handleSave = async () => {
        if (!name && !mobile && !password && !state && !district && !address1 && !address2 && !city && !town && !pincode) {
            setMessage("All Fileds are Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const categoryEditData = {
                    user_name: name,
                    mobile_number: mobile,
                    address_line1: address1,
                    address_line2: address2,
                    city: city,
                    town: town,
                    state_id: state,
                    district_id: district,
                    country: 'India',
                    user_password: password,
                    profile_image_url: '',
                    pincode: pincode,
                    isActive: 0
                };
                try {
                    let url = webEndPoint + "users/" + editState.rfId;
                    const response = await makeRequest("put", url, categoryEditData);
                    if (response) {
                        resetForm();
                        setLoading(false);
                        setMessage("User Updated Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            } else {
                const categoryAddData = {
                    user_name: name,
                    mobile_number: mobile,
                    address_line1: address1,
                    address_line2: address2,
                    city: city,
                    town: town,
                    state_id: state,
                    district_id: district,
                    country: 'India',
                    user_password: password,
                    profile_image_url: '',
                    pincode: pincode,
                    isActive: 0
                };
                try {
                    let url = webEndPoint + "users";
                    const response = await makeRequest("post", url, categoryAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("User Added Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
            setDataSource([]);
            fetchUserstData();
            setSnackbar(true);
            setOpen(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const assignPlan = async (plan) => {
        setLoading(true);
        setAssignedPlan(plan);
        setOpenPlanModal(false);
        setOpenCustomerModal(false);
        const today = new Date().toISOString().split('T')[0];
        const planAddData = {
            user_id: selectedUser?.rfId,
            plan_id: plan?.rfId,
            enrollment_date: today
        };
        try {
            let url = webEndPoint + "user-plans/assign";
            const response = await makeRequest("post", url, planAddData);
            if (response) {
                setLoading(false);
                setMessage("User Plan Added Successfully");
                setSnackbar(true);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }
    const filteredState = dataSource?.filter((d) =>
        d?.user_name?.toLowerCase().includes(search?.toLowerCase()) || d?.mobile_number?.toLowerCase().includes(search?.toLowerCase())
    );
    const filteredData = dataSource?.filter((d) =>
        d?.user_name?.toLowerCase().includes(searchTerm?.toLowerCase()) || d?.mobile_number?.toLowerCase().includes(searchTerm?.toLowerCase())
    );
    const customerColumns = ["S.No", "User Name", "Mobile", "City", "District", "Action"];
    const customerRows = filteredData?.map((u, i) => [i + 1, u.user_name, u.mobile_number, u.city, u.district_name,
    <Button variant="contained" onClick={() => { setSelectedUser(u); setOpenPlanModal(true); }}>select User</Button>
    ]);
    const planColumns = ["S.No", "Category", "Plan Name", "Duration", "Price (₹)", "Action"];
    const planRows = planData?.map((p, i) => [i + 1,p.plan_name, p.saving_plan_name, p.plan_duration + ' ' + p.plan_type, p?.plan_starting_amount,
    <Button variant="contained" onClick={() => { assignPlan(p) }}>Assign Plan</Button>]);
    const columns = ["S.No", "User Name", "Mobile", "City", "District", "Action"];
    const rows = filteredState?.map((u, i) => [i + 1, u.user_name, u.mobile_number, u.city, u.district_name,
    <Box>
        <Tooltip title="Edit">
            <IconButton color="primary" onClick={() => openEdit(u)}>
                <EditIcon />
            </IconButton>
        </Tooltip>
    </Box>
    ]);
    const handleTogglePassword = () => {
        setShowPassword((prev) => !prev);
    };
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Users</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search User Name / Mobile Number" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, gap: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpenCustomerModal(true)}>Assign Plan</Button>
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd}>Add User</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            {open && (
                <Box sx={{ position: "fixed", top: 50, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 1000, maxHeight: "75vh", overflowY: "auto" }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>{editState !== null ? "Edit User" : "Add User"}</Typography>
                        <TextField label="User Name" value={name} onChange={(e) => setName(e.target.value)} sx={{ mb: 2 }} fullWidth />
                        <TextField label="Mobile Number" value={mobile} onChange={(e) => setMobile(e.target.value)} sx={{ mb: 2 }} fullWidth />
                        <TextField label="Password" type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} sx={{ mb: 2 }} fullWidth InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleTogglePassword} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }} />
                        <TextField label="Country" value={country} disabled sx={{ mb: 2 }} fullWidth />
                        <TextField select label="State" value={state} onChange={handleStateChange} sx={{ mb: 2 }} fullWidth SelectProps={{ MenuProps: { PaperProps: { style: { maxHeight: 250, }, }, }, }}>
                            {stateData?.map((s) => (
                                <MenuItem key={s?.rfId} value={s?.rfId}>{s?.state_name}</MenuItem>
                            ))}
                        </TextField>
                        <TextField select label="District" value={district} onChange={(e) => setDistrict(e.target.value)} sx={{ mb: 2 }} fullWidth SelectProps={{ MenuProps: { PaperProps: { style: { maxHeight: 250, }, }, }, }}>
                            {districtData?.map((d) => (
                                <MenuItem key={d?.district_id} value={d?.district_id}>{d?.district_name}</MenuItem>
                            ))}
                        </TextField>
                        <TextField label="Address Line 1" value={address1} onChange={(e) => setAddress1(e.target.value)} sx={{ mb: 2 }} fullWidth />
                        <TextField label="Address Line 2" value={address2} onChange={(e) => setAddress2(e.target.value)} sx={{ mb: 2 }} fullWidth />
                        <TextField label="Town" value={town} onChange={(e) => setTown(e.target.value)} sx={{ mb: 2 }} fullWidth />
                        <TextField label="City" value={city} onChange={(e) => setCity(e.target.value)} sx={{ mb: 2 }} fullWidth />
                        <TextField label="Pin Code" value={pincode} onChange={(e) => setPincode(e.target.value)} sx={{ mb: 2 }} fullWidth />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
                            <Button onClick={() => { resetForm(); setOpen(false) }}>Cancel</Button>
                            <Button variant="contained" onClick={handleSave}>Save</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            {openCustomerModal && (
                <Box sx={{
                    position: "fixed", top: 50, left: 0, width: "100%", height: "100%",
                    bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center",
                    justifyContent: "center", zIndex: 1200
                }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 900, maxHeight: "75vh", overflowY: "auto" }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>Select Customer</Typography>
                        <TextField placeholder="Search by User Name / Mobile Number" fullWidth value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} sx={{ mb: 2 }} InputProps={{ startAdornment: <SearchIcon /> }} />
                        <DataTable columns={customerColumns} rows={customerRows} loading={false} />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                            <Button onClick={() => setOpenCustomerModal(false)}>Close</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            {openPlanModal && selectedUser && (
                <Box sx={{
                    position: "fixed", top: 50, left: 0, width: "100%", height: "100%",
                    bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center",
                    justifyContent: "center", zIndex: 1300
                }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 900, maxHeight: "75vh", overflowY: "auto" }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>Select Plan for {selectedUser.name}</Typography>
                        <DataTable columns={planColumns} rows={planRows} loading={false} />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                            <Button onClick={() => setOpenPlanModal(false)}>Close</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            {/* {assignedPlan && selectedUser && (
                <Box sx={{ mt: 2 }}>
                    <Typography><strong>{assignedPlan.name}</strong> assigned to <strong>{selectedUser.name}</strong></Typography>
                </Box>
            )} */}
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}